import React from "react";
import { LayoutGrid, LayoutGridCell } from "@cdk-uip/react-layout-grid";
import { SystemMessage } from "@cdk-uip/react-system-messages";
import { Headline3 } from "@cdk-uip/react-typography";

import ReactGA from "react-ga";

const NotFound = () => (
  <LayoutGrid>
    {ReactGA.pageview("404-page-not-found")}
    <LayoutGridCell
      spanDesktop={3}
      spanTablet={1}
      spanPhone={0}
    ></LayoutGridCell>
    <LayoutGridCell span={6}>
      <SystemMessage critical id="error-message">
        <Headline3>404 Page not found!</Headline3>
        <p>We're sorry, the page you requested could not me found.</p>
      </SystemMessage>
    </LayoutGridCell>
    <LayoutGridCell
      spanDesktop={3}
      spanTablet={1}
      spanPhone={0}
    ></LayoutGridCell>
  </LayoutGrid>
);

export default NotFound;
